export default "__VITE_ASSET__e27a67d5__"